import { ImagableInterface, ExifInterface } from '@/types/models'

// import { getFirebaseStorageUrl } from '@/firebase/storage'
import { getImageUrl } from '@/firebase/storage/url'
import { getStoragePathSize } from '@/helpers/paths'

const IMAGE_SIZE_SMALL = 40
const IMAGE_SIZE_MEDIUM = 200
const IMAGE_SIZE_LARGE = 2560

// interface ImageUrl {
//   orig: string;
//   s: string;
//   m: string;
//   l: string;
// }

export interface ImageDimensions {
  width: number
  height: number
}

interface ImageSizeMap<T> {
  orig: T
  s: T
  m: T
  l: T
}

const getImageConstrainedMult = (image: Imagable, maxSize: number): number => {
  return maxSize / Math.max(image.width, image.height)
}

export default class Imagable {
  fullpath: string
  bucket: string
  token: string | null
  width: number
  height: number
  exif?: ExifInterface
  // takenAt?: Date;
  protected _takenAt?: Date

  constructor(data: ImagableInterface) {
    this.fullpath = data.fullpath
    this.bucket = data.bucket
    this.token = data.token
    this.width = data.width
    this.height = data.height
    this.exif = data.exif
    this.takenAt = data.takenAt
  }

  get isValid(): boolean {
    return !!this.fullpath && !!this.bucket
  }

  get takenAt(): Date | undefined {
    return this._takenAt
  }

  set takenAt(val: Date | undefined) {
    this._takenAt = val
  }

  get aspectRatio(): number {
    return this.width / this.height
  }

  get dimensions(): ImageSizeMap<ImageDimensions> {
    const sMult = getImageConstrainedMult(this, IMAGE_SIZE_SMALL)
    const mMult = getImageConstrainedMult(this, IMAGE_SIZE_MEDIUM)
    const lMult = getImageConstrainedMult(this, IMAGE_SIZE_LARGE)

    return {
      orig: { width: this.width, height: this.height },
      s: { width: this.width * sMult, height: this.height * sMult },
      m: { width: this.width * mMult, height: this.height * mMult },
      l: { width: this.width * lMult, height: this.height * lMult },
    }
  }

  get url(): ImageSizeMap<string> {
    return {
      // orig: getFirebaseStorageUrl(this.bucket, this.fullpath, this.token || ''),
      // s: getFirebaseStorageUrl(this.bucket, this.fullpath, this.token || '', IMAGE_SIZE_SMALL),
      // m: getFirebaseStorageUrl(this.bucket, this.fullpath, this.token || '', IMAGE_SIZE_MEDIUM),
      // l: getFirebaseStorageUrl(this.bucket, this.fullpath, this.token || '', IMGAE_SIZE_LARGE),
      orig: getImageUrl(this),
      s: getImageUrl(this, IMAGE_SIZE_SMALL),
      m: getImageUrl(this, IMAGE_SIZE_MEDIUM),
      l: getImageUrl(this, IMAGE_SIZE_LARGE),
    }
  }

  get fullpaths(): ImageSizeMap<string> {
    return {
      orig: this.fullpath,
      s: getStoragePathSize(this.fullpath, IMAGE_SIZE_SMALL),
      m: getStoragePathSize(this.fullpath, IMAGE_SIZE_MEDIUM),
      l: getStoragePathSize(this.fullpath, IMAGE_SIZE_LARGE),
    }
  }

  public static sizes: { abbr: 's' | 'm' | 'l'; size: number }[] = [
    { abbr: 's', size: IMAGE_SIZE_SMALL },
    { abbr: 'm', size: IMAGE_SIZE_MEDIUM },
    { abbr: 'l', size: IMAGE_SIZE_LARGE },
  ]
}
